import React from "react";
import { Box, Button, Container, Stack, Typography, alpha } from "@mui/material";
import ArrowForwardOutlined from "@mui/icons-material/ArrowForwardOutlined";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useCustomTheme } from "../../utils/useCustomTheme";
import { TranslateContext } from "../../context/TranslateContext";

export default function CtaBanner() {
  const history = useHistory();
  const { lang } = React.useContext(TranslateContext);
  const { config, isDark } = useCustomTheme();
  const accent = isDark ? config.primary_dark || config.primary : config.primary;
  // MUI contained buttons force primary.contrastText (often white) — use explicit dark on white
  const ctaBtnText =
    config.primary && config.primary.toLowerCase() !== "#ffffff"
      ? config.primary
      : "#4338ca";

  return (
    <Box
      sx={{
        py: { xs: 4, md: 5 },
        px: 2,
      }}
    >
      <Container maxWidth="md">
        <Box
          sx={{
            textAlign: "center",
            py: { xs: 4, md: 5 },
            px: { xs: 3, md: 5 },
            borderRadius: 4,
            background: `linear-gradient(135deg, ${alpha(accent, 0.9)} 0%, ${alpha(config.secondary || accent, 0.85)} 100%)`,
            boxShadow: `0 24px 64px ${alpha(accent, 0.35)}`,
          }}
        >
          <Typography
            variant="h4"
            fontWeight={800}
            color="#fff"
            letterSpacing="-0.02em"
            gutterBottom
          >
            {lang?.homeCtaTitle || "Start clipping, storytelling & selling today"}
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: "rgba(255,255,255,0.88)", mb: 3, maxWidth: 520, mx: "auto", lineHeight: 1.65 }}
          >
            {lang?.homeCtaSubtitle ||
              "Join creators earning from AI clipping, faceless story channels, and high-converting product ads. Choose a plan and start creating."}
          </Typography>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={1.5} justifyContent="center">
            <Button
              variant="contained"
              disableElevation
              size="large"
              endIcon={<ArrowForwardOutlined />}
              onClick={() => history.push("/user/signup")}
              sx={{
                bgcolor: "#fff !important",
                color: `${ctaBtnText} !important`,
                fontWeight: 700,
                textTransform: "none",
                px: 3,
                boxShadow: "0 4px 14px rgba(0,0,0,0.12)",
                "& .MuiButton-endIcon": { color: "inherit !important" },
                "&:hover": {
                  bgcolor: "rgba(255,255,255,0.92) !important",
                  color: `${ctaBtnText} !important`,
                },
              }}
            >
              {lang?.homeCtaPrimary || "Get started free"}
            </Button>
            <Button
              variant="outlined"
              size="large"
              onClick={() => {
                const el = document.getElementById("pricing");
                el?.scrollIntoView({ behavior: "smooth" });
              }}
              sx={{
                borderColor: "rgba(255,255,255,0.6)",
                color: "#fff",
                fontWeight: 600,
                textTransform: "none",
                "&:hover": { borderColor: "#fff", bgcolor: "rgba(255,255,255,0.1)" },
              }}
            >
              {lang?.homeCtaSecondary || "View pricing"}
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
